import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Image , Header , Icon , Segment , Table ,Button } from 'semantic-ui-react';
import dPayMobileApp from '../../../assets/feature/dPay/dPayMobileApp.png';

const styles = {
	container : {
		padding : '20px'
	},
	header : {
		padding : '20px'
	},
	imageContainer : {
		display : 'flex',
		alignItems : 'center',
    flexDirection : 'column',
    justifyContent : 'center',
	},
	descriptionContainer : {
		padding : '20px'
	}
}

class DPayApp extends Component {
	render(){
		const { string } = this.props;
		return (
			<Grid.Row columns='1' style={styles.container}>
				<Grid.Column>
					<Segment.Group> 
					 <Segment style={styles.header}>
					 	<Header as='h2'>{string['dPayApp']}</Header>
					 </Segment>	
					 <Segment>
					 	<Grid stackable>
							<Grid.Row columns='2'>
								<Grid.Column style={styles.imageContainer}>
									<Image src={dPayMobileApp} size={'massive'}/>
								</Grid.Column>
								<Grid.Column style={styles.descriptionContainer}>
									<Header as='h3'>{string['dPayMobileAppDesc1']}</Header>	
									<a href='http://www.dpay.network'><Button>{string['dPayWebsite']}</Button></a>
								</Grid.Column>	
							</Grid.Row>
						</Grid>
					 </Segment>					 
					</Segment.Group>
				</Grid.Column>
			</Grid.Row>
		)
	}
}
		
function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(DPayApp)



/** WEBPACK FOOTER **
 ** ./src/containers/features/dPay/dPayApp.js
 **/